<template>
  <div class="nowrapDiv">
    <div class="width6" style="display: flex; justify-content: center;">
      <template v-for="(info, index) in positionInfo.slice(0, 12)" :key="index">
        <div v-if="info.checked" class="ngdiv"></div>
        <div v-else class="ngdiv1"></div>
      </template>
    </div>
  </div>
  <div class="nowrapDiv">
    <div class="width6" style="display: flex; justify-content: center;">
      <template v-for="(info, index) in positionInfo.slice(12, 24)" :key="index">
        <div v-if="info.checked" class="ngdiv"></div>
        <div v-else class="ngdiv1"></div>
      </template>
    </div>
  </div>
  <div class="nowrapDiv">
    <div class="width6" style="display: flex; justify-content: center;">
      <template v-for="(info, index) in positionInfo.slice(24, 36)" :key="index">
        <div v-if="info.checked" class="ngdiv"></div>
        <div v-else class="ngdiv1"></div>
      </template>
    </div>
  </div>
  <div class="nowrapDiv">
    <div class="width6" style="display: flex; justify-content: center;">
      <template v-for="(info, index) in positionInfo.slice(36, 48)" :key="index">
        <div v-if="info.checked" class="ngdiv"></div>
        <div v-else class="ngdiv1"></div>
      </template>
    </div>
  </div>
  <div class="nowrapDiv">
    <div class="width6" style="display: flex; justify-content: center;">
      <template v-for="(info, index) in positionInfo.slice(48, 60)" :key="index">
        <div v-if="info.checked" class="ngdiv"></div>
        <div v-else class="ngdiv1"></div>
      </template>
    </div>
  </div>
  <div class="nowrapDiv">
    <div class="width6" style="display: flex; justify-content: center;">
      <template v-for="(info, index) in positionInfo.slice(60, 72)" :key="index">
        <div v-if="info.checked" class="ngdiv"></div>
        <div v-else class="ngdiv1"></div>
      </template>
    </div>
  </div>
  <div class="nowrapDiv">
    <div class="width6" style="display: flex; justify-content: center;">
      <template v-for="(info, index) in positionInfo.slice(72, 84)" :key="index">
        <div v-if="info.checked" class="ngdiv"></div>
        <div v-else class="ngdiv1"></div>
      </template>
    </div>
  </div>
  <div class="nowrapDiv">
    <div class="width6" style="display: flex; justify-content: center;">
      <template v-for="(info, index) in positionInfo.slice(84, 96)" :key="index">
        <div v-if="info.checked" class="ngdiv"></div>
        <div v-else class="ngdiv1"></div>
      </template>
    </div>
  </div>
  <div class="nowrapDiv">
    <div class="width6" style="display: flex; justify-content: center;">
      <template v-for="(info, index) in positionInfo.slice(96, 108)" :key="index">
        <div v-if="info.checked" class="ngdiv"></div>
        <div v-else class="ngdiv1"></div>
      </template>
    </div>
  </div>
  <div class="nowrapDiv">
    <div class="width6" style="display: flex; justify-content: center;">
      <template v-for="(info, index) in positionInfo.slice(108, 120)" :key="index">
        <div v-if="info.checked" class="ngdiv"></div>
        <div v-else class="ngdiv1"></div>
      </template>
    </div>
  </div>
  <div class="nowrapDiv">
    <div class="width6" style="display: flex; justify-content: center;">
      <template v-for="(info, index) in positionInfo.slice(120, 132)" :key="index">
        <div v-if="info.checked" class="ngdiv"></div>
        <div v-else class="ngdiv1"></div>
      </template>
    </div>
  </div>
  <div class="nowrapDiv">
    <div class="width6" style="display: flex; justify-content: center;">
      <template v-for="(info, index) in positionInfo.slice(132, 144)" :key="index">
        <div v-if="info.checked" class="ngdiv"></div>
        <div v-else class="ngdiv1"></div>
      </template>
    </div>
  </div>
  <div class="nowrapDiv">
    <div class="width6" style="display: flex; justify-content: center;">
      <template v-for="(info, index) in positionInfo.slice(144, 156)" :key="index">
        <div v-if="info.checked" class="ngdiv"></div>
        <div v-else class="ngdiv1"></div>
      </template>
    </div>
  </div>
  <div class="nowrapDiv">
    <div class="width6" style="display: flex; justify-content: center;">
      <template v-for="(info, index) in positionInfo.slice(156, 168)" :key="index">
        <div v-if="info.checked" class="ngdiv"></div>
        <div v-else class="ngdiv1"></div>
      </template>
    </div>
  </div>
  <div class="nowrapDiv">
    <div class="width6" style="display: flex; justify-content: center;">
      <template v-for="(info, index) in positionInfo.slice(168, 180)" :key="index">
        <div v-if="info.checked" class="ngdiv"></div>
        <div v-else class="ngdiv1"></div>
      </template>
    </div>
  </div>
  <div class="nowrapDiv">
    <div class="width6" style="display: flex; justify-content: center;">
      <template v-for="(info, index) in positionInfo.slice(180, 192)" :key="index">
        <div v-if="info.checked" class="ngdiv"></div>
        <div v-else class="ngdiv1"></div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "BusTzQclLoadMaterialRecord",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      positionInfo: []
    }
  },
  methods: {
    async getLoadMaterialPosition() {
      let {data: res} = await this.$axios.post('bus/tz/getLoadMaterialPosition', this.parentData.id);
      if (res.code !== 0) {
        this.$message.error(res.message)
      } else {
        this.positionInfo = res.data
      }
    }
  },
  created() {
    this.getLoadMaterialPosition()
  }
}
</script>

<style scoped>
.checkInfo{
  background-color: #F4F8FD;
}
.detail{
  background-color: #FFFFFF;
  margin: 5px;
  border-radius: 5px;
  padding: 5px;
  font-size: 16px;
}
.detailDiv{
  width: 50%;
  display: flex;
  flex-wrap: nowrap;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.fontBold{
  font-weight: bold;
}
.width1{
  width: 25%;
}
.width2{
  width: 39%;
}
.width3{
  width: 12.5%;
}
.width4{
  width: 30%;
}
.width5{
  width: 50%;
}
.width5{
  width: 100%;
}
.nowrapDiv{
  display: flex;
  flex-wrap: nowrap;
}
.ngdiv{
  width: 50px;
  height: 25px;
  background-color: #00ff4c;
  margin-right: 5px;
  margin-bottom: 5px;
}
.ngdiv1{
  width: 50px;
  height: 25px;
  background-color: #F1F1F1;
  margin-right: 5px;
  margin-bottom: 5px;
}
.imageStyle{
  width: 87px;
  height: 87px;
  margin-right: 5px
}
</style>